/** @file Maps image-normalized UVs onto atlas page UVs for one region (trim offsets and rotation). */
import type { AtlasRegion } from '@pose2d/format/types';

/**
 * Writes page UVs (u,v pairs) into out for UVs normalized to the original (untrimmed) image. `region.x/y/w/h` is
 * the trimmed content (image orientation); the top trim is offT = origH - h - offB. A `rotated` region holds its
 * content stored 90 degrees counter-clockwise (h wide, w tall on the page). Only `uvs.length` entries are written.
 */
export function regionUv(out: Float32Array, uvs: ArrayLike<number>, region: AtlasRegion, pageW: number, pageH: number): void {
  const offT = region.origH - region.h - region.offB;
  for (let i = 0; i + 1 < uvs.length; i += 2) {
    const rx = (uvs[i] ?? 0) * region.origW - region.offL;
    const ry = (uvs[i + 1] ?? 0) * region.origH - offT;
    if (region.rotated) {
      out[i] = (region.x + ry) / pageW;
      out[i + 1] = (region.y + region.w - rx) / pageH;
    } else {
      out[i] = (region.x + rx) / pageW;
      out[i + 1] = (region.y + ry) / pageH;
    }
  }
}
